import * as React from 'react';
import { BreakpointKey, useHoneycombTheme } from '../../theming';
import { ImageSet } from '../../types';
import { ImageBase, ImageBaseProps } from '../ImageBase/ImageBase';

export interface PictureProps extends ImageBaseProps {
    /**
     * An object which defines an appropriate image source per breakpoint rule.
     */
    imageSet: ImageSet;
}

export function Picture(props: Readonly<PictureProps>): React.JSX.Element {
    const { imageSet, disableLazy, ref, ...other } = props;

    const { theme } = useHoneycombTheme();
    const reversedBreakpointKeys = [...theme.breakpoints.keys].reverse();

    // We need to apply the source elements in order of specificity
    const keys = (Object.keys(imageSet) as BreakpointKey[]).sort(
        (a, b) => reversedBreakpointKeys.indexOf(a) - reversedBreakpointKeys.indexOf(b)
    );

    return (
        <picture>
            {keys.map((key) => {
                const width = theme.breakpoints.values[key];
                const mediaQuery = width > 0 ? `(min-width: ${width}px)` : null;
                const src = imageSet[key as keyof ImageSet];
                return (
                    <source
                        srcSet={disableLazy ? src : undefined}
                        data-srcset={!disableLazy ? src : undefined}
                        media={mediaQuery || undefined}
                        key={key}
                    />
                );
            })}
            <ImageBase ref={ref} isPicture={true} disableLazy={disableLazy} {...other} />
        </picture>
    );
}
